import { render, staticRenderFns } from "./GruposAlumnos.vue?vue&type=template&id=f2035eda&scoped=true"
import script from "./GruposAlumnos.vue?vue&type=script&lang=js"
export * from "./GruposAlumnos.vue?vue&type=script&lang=js"
import style0 from "./GruposAlumnos.vue?vue&type=style&index=0&id=f2035eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2035eda",
  null
  
)

export default component.exports